import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import clsx from 'clsx'

import type { ITheme } from '@homeviews/styles'
import { Typography } from '@material-ui/core'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginRight: 25,
      marginBottom: 20,
      '&:last-child': {
        marginRight: 0,
      },
    },
    value: {
      lineHeight: '18px',
      fontWeight: 500,
      color: '#00A193',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    title: {
      letterSpacing: '-0.2px',
      lineHeight: '18px',
      fontWeight: 500,
      color: theme.colors.grey800,
      marginTop: theme.spacing(0.75),
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    circleWrapper: {
      position: 'relative',
    },
    bottom: {
      color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    top: {
      position: 'absolute',
      left: 0,
    },
    circle: {
      strokeLinecap: 'round',
      stroke: '#00A193',
    },
  }),
)

export default function CustomizedProgressBars({
  value,
  title,
  size = 50,
  className,
}) {
  const classes = useStyles()

  const percentage = value * 20

  if (typeof value === 'undefined' || value === 'No value') {
    return null
  }

  return (
    <div className={clsx(classes.root, className)}>
      <div
        className={classes.circleWrapper}
        style={{
          height: `${size}px`,
          width: `${size}px`,
        }}
      >
        <CircularProgress
          variant="determinate"
          className={classes.bottom}
          size={size}
          thickness={4}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          className={classes.top}
          classes={{
            circle: classes.circle,
          }}
          size={size}
          thickness={4}
          value={percentage}
        />
        <Typography className={classes.value}>{value}</Typography>
      </div>
      <Typography className={classes.title}>{title}</Typography>
    </div>
  )
}
